import React, { useEffect, useId, useRef, useState } from "react";
import { linkUrlError } from "./helpers";
import * as S from "./styles";

type LinkRowPropsT = {
  initialText: string;
  onInsert: (text: string, url: string) => void;
  onCancel: () => void;
};

const LinkRow = ({ initialText, onInsert, onCancel }: LinkRowPropsT) => {
  const [text, setText] = useState(initialText);
  const [url, setUrl] = useState("");
  const [error, setError] = useState<string | null>(null);
  const urlRef = useRef<HTMLInputElement>(null);
  const errorId = useId();

  useEffect(() => {
    urlRef.current?.focus();
  }, []);

  const insert = () => {
    const urlError = linkUrlError(url);
    if (urlError) {
      setError(urlError);
      return;
    }
    onInsert(text, url);
  };

  return (
    <S.LinkRow role="group" aria-label="Insert link">
      <S.LinkFields>
        <S.LinkTextInput
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder="Link text"
          aria-label="Link text"
        />
        <S.LinkUrlInput
          ref={urlRef}
          value={url}
          onChange={(event) => {
            setUrl(event.target.value);
            setError(null);
          }}
          onKeyDown={(event) => {
            if (event.key !== "Enter") return;
            event.preventDefault();
            if (url.trim()) insert();
          }}
          placeholder="https://"
          aria-label="Link URL"
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
        />
        <S.LinkInsertButton type="button" onClick={insert} disabled={!url.trim()}>
          Insert
        </S.LinkInsertButton>
        <S.LinkCancelButton type="button" onClick={onCancel}>
          Cancel
        </S.LinkCancelButton>
      </S.LinkFields>
      {error && (
        <S.LinkError id={errorId} role="alert">
          {error}
        </S.LinkError>
      )}
    </S.LinkRow>
  );
};

export default LinkRow;
